import SiteNav from "@/components/feature/SiteNav";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import CategoryOverview from "./components/CategoryOverview";
import MovieExplorer from "./components/MovieExplorer";
import HotSeries from "./components/HotSeries";
import WesternPicks from "./components/WesternPicks";
import DomesticPicks from "./components/DomesticPicks";
import WatchGuide from "./components/WatchGuide";
import FaqSection from "./components/FaqSection";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteNav />

      <main className="w-full">
        <Hero />
        <CategoryOverview />
        <MovieExplorer />
        <HotSeries />
        <WesternPicks />
        <DomesticPicks />
        <WatchGuide />

        <section className="w-full px-4 md:px-6 py-12 md:py-16">
          <div className="rounded-lg bg-primary-500 px-6 md:px-12 py-10 md:py-12 flex flex-col lg:flex-row lg:items-center justify-between gap-6">
            <div className="max-w-2xl">
              <h2 className="text-xl md:text-2xl font-bold text-background-50 leading-snug">
                已经有想看的类型了？直接开始筛选
              </h2>
              <p className="mt-3 text-sm leading-7 text-background-50/90">
                按地区与类型筛选最新电影，或到热播剧集、欧美大片与国产剧分区继续浏览，
                也可以先看看选片指南再决定。
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <a
                href="#movies"
                className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-background-50 text-primary-700 text-sm font-medium whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-filter-3-line"></i>
                筛选最新电影
              </a>
              <a
                href="#guide"
                className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-700 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-800 transition-colors cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                查看选片指南
              </a>
            </div>
          </div>
        </section>

        <FaqSection />
      </main>

      <SiteFooter />
    </div>
  );
}